import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGritStatics} from "../TrueGritStatics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TrueGrit} from "../TrueGrit";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TrueGritSymbol} from "../reels/TrueGritSymbol";

/**
 * Created by Jerker Nord on 2021-12-09.
 */

export class TrueGritXWaysAndSplitView extends PIXI.Container implements StageLayer {

    private static LOW_SPLIT_ANIMATION_OFFSET:PIXI.Point = new PIXI.Point(72, 72);
    private static MID_SPLIT_ANIMATION_OFFSET:PIXI.Point = new PIXI.Point(72, 72);
    private static WILD_SPLIT_ANIMATION_OFFSET:PIXI.Point = new PIXI.Point(72, 72);
    private static XWAY_ANIMATION_OFFSET:PIXI.Point = new PIXI.Point(72, 72);
    private static BOTTOM_REEL_OFFSET:PIXI.Point = new PIXI.Point(1, 6);
    private static INFECTIOUS_SHINE_OFFSET:PIXI.Point = new PIXI.Point(72, 72);

    private _lowSplits:PIXI.spine.Spine[][];
    private _midSplits:PIXI.spine.Spine[][];
    private _wildSplits:PIXI.spine.Spine[][];
    private _xWays:PIXI.spine.Spine[][];
    private _infectiousShine:TimelineSprite[][];

    constructor() {
        super();
        this.name = "TrueGritSpineSplitSymbolView";
        this.init();
    }

    private init() {
        this._lowSplits = [];
        let tempSplitAnimation:PIXI.spine.Spine;

        for(let i:number = 0; i < 6; i++) {
            const subSplitAnimations:PIXI.spine.Spine[] = [];
            for(let j:number = 0; j < 4; j++) {
                tempSplitAnimation = new PIXI.spine.Spine(TrueGrit.assetLoader.getSpineAsset(TrueGritGameAssets.LOW_SPLIT_SPINE));
                tempSplitAnimation.position = TrueGritXWaysAndSplitView.LOW_SPLIT_ANIMATION_OFFSET;
                tempSplitAnimation.position.x += i * TrueGritStatics.symbolWidth;
                tempSplitAnimation.position.y += j * TrueGritStatics.symbolHeight;
                tempSplitAnimation.visible = false;
                this.addChild(tempSplitAnimation);

                subSplitAnimations.push(tempSplitAnimation);
            }
            this._lowSplits.push(subSplitAnimations);
        }
        this._lowSplits[2][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._lowSplits[2][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;
        this._lowSplits[3][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._lowSplits[3][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;
        this._lowSplits[4][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._lowSplits[4][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;

        this._midSplits = [];
        for(let i:number = 0; i < 6; i++) {
            const subSplitAnimations:PIXI.spine.Spine[] = [];
            for(let j:number = 0; j < 4; j++) {
                tempSplitAnimation = new PIXI.spine.Spine(TrueGrit.assetLoader.getSpineAsset(TrueGritGameAssets.MID_SPLIT_SPINE));
                tempSplitAnimation.position = TrueGritXWaysAndSplitView.MID_SPLIT_ANIMATION_OFFSET;
                tempSplitAnimation.position.x += i * TrueGritStatics.symbolWidth;
                tempSplitAnimation.position.y += j * TrueGritStatics.symbolHeight;
                tempSplitAnimation.visible = false;
                this.addChild(tempSplitAnimation);

                subSplitAnimations.push(tempSplitAnimation);
            }
            this._midSplits.push(subSplitAnimations);
        }
        this._midSplits[2][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._midSplits[2][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;
        this._midSplits[3][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._midSplits[3][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;
        this._midSplits[4][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._midSplits[4][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;

        this._wildSplits = [];
        for(let i:number = 0; i < 6; i++) {
            const subSplitAnimations:PIXI.spine.Spine[] = [];
            for(let j:number = 0; j < 4; j++) {
                tempSplitAnimation = new PIXI.spine.Spine(TrueGrit.assetLoader.getSpineAsset(TrueGritGameAssets.WILD_SPLIT_SPINE));
                tempSplitAnimation.position = TrueGritXWaysAndSplitView.WILD_SPLIT_ANIMATION_OFFSET;
                tempSplitAnimation.position.x += i * TrueGritStatics.symbolWidth;
                tempSplitAnimation.position.y += j * TrueGritStatics.symbolHeight;
                tempSplitAnimation.visible = false;
                this.addChild(tempSplitAnimation);

                subSplitAnimations.push(tempSplitAnimation);
            }
            this._wildSplits.push(subSplitAnimations);
        }
        /*
        this._midSplits[2][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._midSplits[2][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;
        this._midSplits[3][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._midSplits[3][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;
        this._midSplits[4][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._midSplits[4][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;

         */

        this._xWays = [];
        for(let i:number = 0; i < 6; i++) {
            const subSplitAnimations:PIXI.spine.Spine[] = [];
            for(let j:number = 0; j < 4; j++) {
                tempSplitAnimation = new PIXI.spine.Spine(TrueGrit.assetLoader.getSpineAsset(TrueGritGameAssets.XWAY_SPINE));
                tempSplitAnimation.position = TrueGritXWaysAndSplitView.XWAY_ANIMATION_OFFSET;
                tempSplitAnimation.position.x += i * TrueGritStatics.symbolWidth;
                tempSplitAnimation.position.y += j * TrueGritStatics.symbolHeight;
                tempSplitAnimation.visible = false;
                this.addChild(tempSplitAnimation);

                subSplitAnimations.push(tempSplitAnimation);
            }
            this._xWays.push(subSplitAnimations);
        }
        this._xWays[2][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._xWays[2][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;
        this._xWays[3][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._xWays[3][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;
        this._xWays[4][3].position.x += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.x;
        this._xWays[4][3].position.y += TrueGritXWaysAndSplitView.BOTTOM_REEL_OFFSET.y;

        this._infectiousShine = [];
        let tempShineAnimation:TimelineSprite;
        for(let i:number = 0; i < 6; i++) {
            const subShineAnimations:TimelineSprite[] = [];
            for(let j:number = 0; j < 4; j++) {
                tempShineAnimation = new TimelineSprite(TrueGrit.assetLoader.getTextures("winAnimations/infect_shine/infect_shine_"));
                tempShineAnimation.position = TrueGritXWaysAndSplitView.INFECTIOUS_SHINE_OFFSET;
                tempShineAnimation.position.x += i * TrueGritStatics.symbolWidth;
                tempShineAnimation.position.y += j * TrueGritStatics.symbolHeight;
                tempShineAnimation.anchor.set(0.5, 0.5);
                tempShineAnimation.visible = false;
                this.addChild(tempShineAnimation);

                subShineAnimations.push(tempShineAnimation);
            }
            this._infectiousShine.push(subShineAnimations);
        }

        this.onResize();
    }

    public getInfectiousRevealAnimations():gsap.core.Timeline[] {
        let revealAnimations:gsap.core.Timeline[] = [];
        let tl:gsap.core.Timeline;
        for(let i:number = 0; i < TrueGrit.model.gameData.xWays.positions.length; i++) {
            tl = gsap.timeline();
            let symbol:TrueGritSymbol;
            tl.add(() => {
                if(TrueGrit.model.gameData.xWays.positions[i] == true) {
                    symbol = (<TrueGritSymbol>TrueGrit.allReelsView.bottomReelModel.reelView.getSymbolBySymbolPosition(i + 1));
                    tl.add(() => {symbol.getSplitAndChangeAnimation(TrueGrit.model.gameData.greatBookOfWays[i + 2][4], TrueGrit.model.gameData.xWays.symbol, true, true)});
                }
            });
            revealAnimations.push(tl);
        }
        return revealAnimations;
    }

    public getInfectiousAttentionAnimations(positions:PIXI.Point[]):gsap.core.Timeline[] {
        let animations:gsap.core.Timeline[] = [];
        let tl:gsap.core.Timeline;
        for(let i:number = 0; i < positions.length; i++) {
            //Don't play attention on the XWays sym(s) on bottom reel
            if(TrueGrit.model.gameData.reels[positions[i].x][positions[i].y + 1] == "M" && (positions[i].y == 3 && positions[i].x > 1)) {
                //Bottom reel M sym
            } else {
                tl = gsap.timeline();
                tl.add(() => {this._infectiousShine[positions[i].x][positions[i].y].getAnimationAutoShowHide().timeScale(1.2)});
                animations.push(tl);
            }
        }
        return animations;
    }

    public getInfectedRevealAnimations(positions:PIXI.Point[]):gsap.core.Timeline[] {
        let animations:gsap.core.Timeline[] = [];
        let tl:gsap.core.Timeline;
        for(let i:number = 0; i < positions.length; i++) {
            tl = gsap.timeline();
            //tl.add(() => this._infectiousShine[positions[i].x][positions[i].y].getAnimationAutoShowHide().timeScale(0.8));
            let symbolRow:number = positions[i].y + 1;
            let symbol:TrueGritSymbol;
            tl.add(() => {
                if(symbolRow < 4 || positions[i].x < 2) {
                    symbol = (<TrueGritSymbol>TrueGrit.allReelsView.mainReelModels[positions[i].x].reelView.getSymbol(symbolRow));
                    if(symbol.symbolName == "M") {
                        tl.add(() => {symbol.getSplitAndChangeAnimation(TrueGrit.model.gameData.greatBookOfWays[positions[i].x][positions[i].y + 1], TrueGrit.model.gameData.xWays.symbol, false, false)});
                    } else {
                        tl.add(() => {symbol.getSplitAnimation(TrueGrit.model.gameData.greatBookOfWays[positions[i].x][positions[i].y + 1])});
                    }
                } else {
                    //Bottom reel
                    if(TrueGrit.model.gameData.botTrain.symbols[positions[i].x - 2] !== "M_infectious") {
                        symbol = (<TrueGritSymbol>TrueGrit.allReelsView.bottomReelModel.getSymbolBySymbolPosition(positions[i].x - 1));
                        tl.add(() => {symbol.getSplitAnimation(TrueGrit.model.gameData.greatBookOfWays[positions[i].x][positions[i].y + 1], true)});
                    }
                }
            }, "+=0.4");
            animations.push(tl);
        }
        return animations;
    }

    public getLowSplitAnimation(splitLevel:number, symbolName:string, reel:number, row:number, isXways:boolean, isInfectious:boolean):TimelineLite {
        const lowSplitTL:gsap.core.Timeline = gsap.timeline();
        if(isXways == true) {
            lowSplitTL.add(() => {
                this._xWays[reel][row].updateTransform();
                this._xWays[reel][row].visible = true;
                if(isInfectious == false) {
                    new SpineTween(this._xWays[reel][row], 0, "m_trigger", 0).timeScale(1.8)
                } else {
                    new SpineTween(this._xWays[reel][row], 0, "m_infectious_trigger", 0)
                }
            });
            lowSplitTL.add(() => {}, "+=0.13");
        }
        if(splitLevel > 1) {
            lowSplitTL.add(() => {
                this._lowSplits[reel][row].updateTransform();
                this._lowSplits[reel][row].visible = true;
                this._lowSplits[reel][row].skeleton.setSkin(null);
                this._lowSplits[reel][row].skeleton.setSkinByName(symbolName);
                this._lowSplits[reel][row].skeleton.setSlotsToSetupPose();
            });
            lowSplitTL.add(new SpineTween(this._lowSplits[reel][row], 0, "split_" + splitLevel, 0));
        }

        lowSplitTL.add(() => {this._lowSplits[reel][row].visible = false});

        return lowSplitTL;
    }

    public getMidSplitAnimation(splitLevel:number, newSplitLevel:number, symbolName:string, reel:number, row:number, isXways:boolean, isInfectious:boolean):TimelineLite {
        if(splitLevel == 0) {
            splitLevel++;
        }
        const midSplitTL:gsap.core.Timeline = gsap.timeline();
        if(isXways == true) {
            midSplitTL.add(() => {
                this._xWays[reel][row].updateTransform();
                this._xWays[reel][row].visible = true;
                if(isInfectious == false) {
                    new SpineTween(this._xWays[reel][row], 0, "m_trigger", 0).timeScale(1.8)
                } else {
                    new SpineTween(this._xWays[reel][row], 0, "m_infectious_trigger", 0)
                }
            });
            midSplitTL.add(() => {}, "+=0.13");
        }
        midSplitTL.add(() => {
            this._midSplits[reel][row].updateTransform();
            this._midSplits[reel][row].visible = true;
            this._midSplits[reel][row].skeleton.setSkin(null);
            this._midSplits[reel][row].skeleton.setSkinByName(symbolName);
            this._midSplits[reel][row].skeleton.setSlotsToSetupPose();
        });

        if(splitLevel == 1) {
            midSplitTL.add(new SpineTween(this._midSplits[reel][row], 0, "split_1_" + newSplitLevel, 0));
        }

        if(splitLevel > 1 && newSplitLevel == 3) {
            midSplitTL.add(new SpineTween(this._midSplits[reel][row], 0, "split_split_3", 0));
        }

        if(splitLevel > 1 && newSplitLevel == 4) {
            midSplitTL.add(new SpineTween(this._midSplits[reel][row], 0, "split_split_4", 0));
        }

        midSplitTL.add(() => {this._midSplits[reel][row].visible = false});

        return midSplitTL;
    }

    public getWildSplitAnimation(splitLevel:number, newSplitLevel:number, symbolName:string, reel:number, row:number):TimelineLite {
        if(splitLevel == 0) {
            splitLevel++;
        }
        const wildSplitTL:gsap.core.Timeline = gsap.timeline();
        wildSplitTL.add(() => {
            this._wildSplits[reel][row].updateTransform();
            this._wildSplits[reel][row].visible = true;
            this._wildSplits[reel][row].skeleton.setSlotsToSetupPose();
        });

        if(splitLevel == 1) {
            wildSplitTL.add(new SpineTween(this._wildSplits[reel][row], 0, "split_1_" + newSplitLevel, 0));
        }

        if(splitLevel > 1 && newSplitLevel == 3) {
            wildSplitTL.add(new SpineTween(this._wildSplits[reel][row], 0, "split_split_3", 0));
        }

        if(splitLevel > 1 && newSplitLevel == 4) {
            wildSplitTL.add(new SpineTween(this._wildSplits[reel][row], 0, "split_split_4", 0));
        }

        wildSplitTL.add(() => {this._wildSplits[reel][row].visible = false});

        return wildSplitTL;
    }

    onResize():void {
        this.position = TrueGritStatics.MAIN_REELS_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }
}